{
  "intro": "Addresses for failover: a floating IP is pointed at any server of its network zone in seconds, running or not. The server's operating system must know the address — configure it on the server. Billed monthly, IPv4 and IPv6 alike, assigned or not.",
  "empty": "No floating IPs yet",
  "emptyLead": "A floating IP lets a service move between servers without changing DNS: for example to a standby server when the main one fails.",
  "create": "Create floating IP",
  "createLead": "A new address in its home location, or straight on a server.",
  "createSubmit": "Create address",
  "created": "Address {{address}} created",
  "name": "Name",
  "nameHint": "To recognise the address in the list, for example by the service it serves.",
  "description": "Description",
  "descriptionHint": "Optional: what this address is for.",
  "family": "Type",
  "ipv4Hint": "One address.",
  "ipv6Hint": "A /64 network.",
  "pricePerMonth": "{{price}} per month",
  "where": "Where",
  "keepFree": "Create in a location, unassigned",
  "onServer": "Point it at a server right away",
  "location": "Home location",
  "locationHint": "Where the address is kept and billed. It can point at any server of the same network zone.",
  "zone": "Network zone {{zone}}",
  "server": "Server",
  "chooseServer": "Choose a server",
  "serverHint": "The server can be running: no need to power it off.",
  "billing": "A floating IP is billed from creation until deletion, assigned to a server or not. A deleted address cannot be brought back: the next one will be different.",
  "configureNote": "After assigning, configure the address in the server's operating system, or the server will not accept its traffic.",
  "address": "Address",
  "home": "Location",
  "unassigned": "Not assigned",
  "dnsShort": "Reverse DNS",
  "flags": "Properties",
  "protected": "Protected",
  "blocked": "Blocked",
  "price": "Per month",
  "createdAt": "Created",
  "assign": "Assign to server",
  "move": "Move to another server",
  "assignTitle": "Point {{address}} at a server",
  "assignLead": "Any server of network zone {{zone}} fits, running or powered off. The switch takes a few seconds.",
  "assigning": "Pointing {{address}} at the server",
  "unassign": "Unassign from server",
  "unassigning": "Unassigning {{address}}",
  "configure": "How to configure on the server",
  "configureTitle": "Configuring {{address}} on the server",
  "configureLead": "Hetzner routes the address's traffic to the server, but the server's system must accept the address itself. Add it to the main network interface (usually eth0).",
  "configureNow": "Right away, until the next reboot:",
  "configurePersist": "Permanently (Ubuntu and Debian with netplan): the file /etc/netplan/60-floating-ip.yaml, then sudo netplan apply:",
  "configureOther": "On other systems add the address to the interface their way. If the address will move between servers, configure it on each of them in advance.",
  "dns": "Reverse DNS",
  "edit": "Name, description and labels",
  "editTitle": "Floating IP {{address}}",
  "labels": "Labels",
  "labelsHint": "One per line: key=value.",
  "labelsInvalid": "Line {{line}}: key and value take up to 63 letters, digits, dots, hyphens and underscores.",
  "protect": "Turn on delete protection",
  "unprotect": "Turn off delete protection",
  "delete": "Delete",
  "deleteTitle": "Delete floating IP {{address}}?",
  "deleteLost": "The address is lost for good: Hetzner will give it to someone else.",
  "deleteServer": "Server {{server}} stops receiving traffic for this address.",
  "deleteDns": "DNS records pointing at this address stop working.",
  "deleteBilling": "Billing for the address stops.",
  "deleted": "Address {{address}} deleted",
  "why": {
    "protected": "Delete protection is on: turn it off first.",
    "blocked": "The address is blocked by the provider.",
    "notAssigned": "The address does not point at any server.",
    "otherZone": "other network zone",
    "current": "points here already",
    "assigned": "The address points at a server: unassign it first."
  },
  "serverCard": {
    "title": "Floating IPs",
    "empty": "No floating IP points at this server.",
    "note": "Each address must be configured in the server's operating system.",
    "manage": "All floating IPs"
  }
}
